<div class="normalScreen" style="background: white">
  <div class="admin-top">
    <div class="row">
      <div class="col-9">
        <svg style="vertical-align: top;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100" viewBox="0 0 26.98 21">
          <defs>
            <style>
              .cls-1, .cls-2, .cls-6 {
                fill: none;
              }

              .cls-1 {
                clip-rule: evenodd;
              }

              .cls-2 {
                fill-rule: evenodd;
              }

              .cls-3 {
                clip-path: url(#clip-path);
              }

              .cls-4 {
                clip-path: url(#clip-path-2);
              }

              .cls-5 {
                fill: #9b9b9b;
              }

              .cls-6 {
                stroke: black;
                stroke-miterlimit: 10;
                stroke-width: 2px;
              }
            </style>
            <clipPath id="clip-path" transform="translate(0.58 1)"><path class="cls-1" d="M24.84.5a.23.23,0,0,1,.06.15v15s0,.05,0,.06L16.91,18.5s0,0,0,0h-.05s0,0,0,0L9.09,15.81l-.16-.06-.17.06L1,18.5H1l-.06,0s0,0,0,0V3.35s0-.06.09-.09L8.92.53H9l7.72,2.68.17.06.16-.06L24.81.5Zm.62-.78a1,1,0,0,0-1-.17L16.72,2.28h.33L9.29-.42a1.31,1.31,0,0,0-.65,0l-8,2.76a1.12,1.12,0,0,0-.72,1v15.1A1,1,0,0,0,1,19.5a1.06,1.06,0,0,0,.35-.05l7.77-2.7H8.76l7.77,2.69a.63.63,0,0,0,.35.06H17a.83.83,0,0,0,.27-.07l7.9-2.75a1,1,0,0,0,.7-1V.58A1.24,1.24,0,0,0,25.46-.28ZM9.65.9l-.17,0H9v14.8l.34.12,6.85,2.36.66.23v-15l-.33-.11Zm-.33,1,6.82,2.36-.34-.47V17.68l.67-.47L9.62,14.84l.33.48V1.37h-.5v.5h0v-.5Zm-8,1.42L1,3.38v15l.67-.23,6.85-2.36.33-.12V.67L8.21.9Zm.33.94L8.54,1.85l-.67-.48v14l.34-.48L1.36,17.21l.66.47V3.74ZM24.42,15.76l.34-.12V.64l-.67.24L17.25,3.27l-.34.11v15l.67-.23Zm-.33-.94-6.84,2.39.66.47V3.74l-.33.47,6.84-2.39-.66-.47V15.29ZM-20.08-20.5h66v60h-66Z" /></clipPath>
            <clipPath id="clip-path-2" transform="translate(0.58 1)"><path class="cls-1" d="M25.15.11a.53.53,0,0,0-.5-.08L16.88,2.75,9.12.05a1.09,1.09,0,0,0-.36,0L.8,2.8a.6.6,0,0,0-.38.55v15.1a.52.52,0,0,0,.22.44A.54.54,0,0,0,1,19a.47.47,0,0,0,.19,0l7.77-2.69L16.69,19a.38.38,0,0,0,.19,0,.46.46,0,0,0,.2,0l8-2.77a.55.55,0,0,0,.36-.53V.58A.7.7,0,0,0,25.15.11ZM9.48,1.37,16.3,3.74V17.68L9.45,15.32V1.37Zm-8,2.37L8.37,1.37v14L1.52,17.68ZM24.26,15.29l-6.85,2.39V3.74l6.85-2.39Z" /></clipPath>
          </defs>
          <g class="cls-3"><g class="cls-4"><path class="cls-5" d="M25.15.11a.53.53,0,0,0-.5-.08L16.88,2.75,9.12.05a1.09,1.09,0,0,0-.36,0L.8,2.8a.6.6,0,0,0-.38.55v15.1a.52.52,0,0,0,.22.44A.54.54,0,0,0,1,19a.47.47,0,0,0,.19,0l7.77-2.69L16.69,19a.38.38,0,0,0,.19,0,.46.46,0,0,0,.2,0l8-2.77a.55.55,0,0,0,.36-.53V.58A.7.7,0,0,0,25.15.11ZM9.48,1.37,16.3,3.74V17.68L9.45,15.32V1.37Zm-8,2.37L8.37,1.37v14L1.52,17.68ZM24.26,15.29l-6.85,2.39V3.74l6.85-2.39Z" transform="translate(0.58 1)" /></g></g>
          <g class="cls-4"><path class="cls-6" d="M25.15.11a.53.53,0,0,0-.5-.08L16.88,2.75,9.12.05a1.09,1.09,0,0,0-.36,0L.8,2.8a.6.6,0,0,0-.38.55v15.1a.52.52,0,0,0,.22.44A.54.54,0,0,0,1,19a.47.47,0,0,0,.19,0l7.77-2.69L16.69,19a.38.38,0,0,0,.19,0,.46.46,0,0,0,.2,0l8-2.77a.55.55,0,0,0,.36-.53V.58A.7.7,0,0,0,25.15.11ZM9.48,1.37,16.3,3.74V17.68L9.45,15.32V1.37Zm-8,2.37L8.37,1.37v14L1.52,17.68ZM24.26,15.29l-6.85,2.39V3.74l6.85-2.39Z" transform="translate(0.58 1)" /></g>
        </svg>
        <div class="mt-2 d-inline-block">
          <h6><small>Mappningen av kartor mot BFS sker på första delen av filnamnet, t.ex 'G1.PNG' mappas till BFS på Gate 1 (G1).</small></h6>
          <h6><small>Filnamnet är unikt vilket innebär att om det laddas upp en ny fil med samma namn ersätts den befintliga filen.</small></h6>
          <h6><small><b>Viktigt:</b> Kartan måste vara av typen PNG och följa överrenskommen design, annars fungerar det inte i BFS-appen.</small></h6>
        </div>
      </div>
      <div class="mt-2 col-3 right-align-text">
        <button mat-flat-button class="upload-button" type="button" (click)="openFile()">
          <input type="file" style="display:none" (change)="handle($event);" accept="image/png">
          <img src="../assets/images/upload-button.svg" width="20" height="20" />Ladda upp
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="fetchingData"><em>Hämtar BFS-kartor...</em></div>
  <div style="width: 100%; ">
    <ag-grid-angular style="height: 50vh; width:100%;"
                     class="ag-theme-material ag-theme-schedule"
                     [gridOptions]="gridOptions"
                     [rowData]="bfsMapList">

    </ag-grid-angular>
  </div>
</div>
